import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { questionValidation } from '../../functions/Validation';
import Question from '../question/Question';
import QuestionHelp from '../question/QuestionHelp';
import './number.scss';
import './propertyOwners.scss';
import ValidationMessage from '../question/ValidationMessage';
import { tracking } from '../../functions/Tracking';
import { Action } from '../../enums/TrackingActionType';

export default function PropertyOwners(props: any) {

    const [question, setQuestion] = useState(props.question);
    const [children, setChildren] = useState(props.question.childInformation);
    const [childrenTemplate, setChildrenTemplate] = useState(props.question.childInformation);
    const [numberValue, setNumberValue] = useState(question.answer);
    const [secondsFocused, setSecondsFocused] = useState(0);
    const [tabs, setTabs] = useState<number[]>([]);
    const timerId = useRef<number>(0);

    var inputClasses = classNames(
        {
            'validation-fail': question.validationFail
        }
    );

    var labelClasses = classNames(
        {
            'validation-fail-lbl': question.validationFail
        }
    );

    useEffect(() => {
        setQuestion(props.question);
        const childrenTabs = [...(children.map((x: { index: any; }) => x.index))];
        const distinctChildrenTabs: number[] = [];
        childrenTabs.forEach(tab => {
            if (!distinctChildrenTabs.includes(tab) && tab > 0) {
                distinctChildrenTabs.push(tab);
            }
        })
        setTabs(distinctChildrenTabs);

        let updatedChildren = children.map((childQuestion: any) => {
            childQuestion.visible = true;
            childQuestion.questionSetQuestion.visible = true;
            return childQuestion;
        });
        setChildren(updatedChildren);

        const templateChildSet = props.question.childInformation.filter((x: { index: number; }) => x.index === 0);
        setChildrenTemplate(templateChildSet);

        if (props.question.answer) {
            setNumberValue(props.question.answer);
        }
    }, [])

    useEffect(() => {
        if (secondsFocused === 60) {
            //alert("Too much time has passed");
            //alert(question.questionSetQuestion.text);
        }
    }, [secondsFocused])

    useEffect(() => {
        question.answer = numberValue;
        setQuestion(question);
        props.enableQuestions(question.questionSetQuestion.questionID);
        // only set the questions if the answer isn't a blank string to prevent answers being lost when changing the number
        // as you'd first need to delete the number before replacing it with a new one and that would clear all answers
        // i.e. changing 4 to 5 would lose all responses for the first 4 records 
        if (numberValue !== "") {
            setQuestionsBasedOnAnswer();
        }
        
    }, [numberValue]);

    const startTimer = () => {
        timerId.current = window.setInterval(() => {
            setSecondsFocused(prev => prev + 1);
        }, 1000);
    };

    const stopTimer = () => {
        clearInterval(timerId.current);
        setSecondsFocused(0);
    };

    const updateAnswer = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumberValue(e.target.value);
    };

    const validateAnswer = () => {
        stopTimer();
        tracking(Action.SAVE_QUESTIONS, question.questionSetQuestion.questionID);
        question.validationFail = !questionValidation(question);

        setQuestion(question);
    };

    const setQuestionsBasedOnAnswer = () => {
        let newTabs: number[] = [];

        var currentChildren: any = [...children];

        for (let i = 1; i <= numberValue; i++) {
            let alreadyExists = currentChildren.some((x: { index: number; }) => x.index === i);
            if (!alreadyExists) {
                let firstChild = structuredClone(childrenTemplate);
                firstChild.map((childQuestion: { index: number; }) => {
                    childQuestion.index = i;
                    currentChildren = [...currentChildren, childQuestion];
                    return childQuestion;
                });
                question.childInformation = currentChildren;
            }

            if (!newTabs.includes(i)) {
                newTabs.push(i);
            }
        }

        var largestTab = Math.max.apply(0, newTabs);

        // remove any child questions whose index goes above the largest tab in the tabs array
        question.childInformation = question.childInformation.filter((x: { index: number; }) => x.index <= largestTab);

        setTabs(newTabs);
        setQuestion(question);
        updateChildren();
    }

    const updateChildren = () => {
        if (parseInt(numberValue) === 0 || numberValue === "") {
            let updatedQuestionChildren = question.childInformation.filter((x: { index: number; }) => x.index === 0);
            let updatedQuestion = question;
            updatedQuestion.childInformation = updatedQuestionChildren;
            setQuestion(updatedQuestion);
            setTabs([]);
            setChildren(updatedQuestion.childInformation);
        } else {
            setChildren([...question.childInformation]);
        }
    }

    return (
        <>
            <div className="question">
                <label className={labelClasses} htmlFor={"valen_" + question.questionSetQuestion.questionID}>{question.questionSetQuestion.text}</label>
                <br />
                <input
                    type="number"
                    value={numberValue}
                    id={"valen_" + question.questionSetQuestion.questionID}
                    className={inputClasses}
                    onChange={(e) => updateAnswer(e)}
                    onFocus={() => startTimer()}
                    onBlur={() => validateAnswer()}
                    min={"0"}
                    max={question.questionSetAnswerType.endRange}
                />
                {question.questionSetQuestion.helpText !== null && question.questionSetQuestion.helpText !== "" &&
                    <QuestionHelp helpText={question.questionSetQuestion.helpText} questionID={question.questionSetQuestion.questionID} />
                }
                {/*<p>Focused: {secondsFocused}</p>*/}
                {question.validationFail &&
                    <ValidationMessage question={question} overrideMessage="" />}
            </div>
            {tabs.map(childTab => {
                return (<div className="property" key={"property_owners_" + childTab}>
                    <p>{"Property Information"} #{childTab}</p>
                    {
                        children.map((childQuestion: any, index: any) => {
                            if (childQuestion.index === childTab) {
                                return <Question question={childQuestion} key={childQuestion.questionSetQuestion.questionID + "_" + childQuestion.index + "_" + childTab} showConditionQuestions={props.showConditionQuestions} enableQuestions={props.enableQuestions} page={props.page} setIndividualCustomerDetails={props.setIndividualCustomerDetails} showConditionalChildren={props.showConditionalChildren} questionIdPosition={props.questionIdPosition + "|" + childQuestion.questionSetQuestion.questionID + "-" + childQuestion.index} setChildResponseAddress={props.setChildResponseAddress} resetRelatedQuestionsValidationOnAnswerChange={props.resetRelatedQuestionsValidationOnAnswerChange} resetCoverValidation={props.resetCoverValidation} />
                            } else {
                                return <></>;
                            }
                        }
                        )
                    }
                </div>)
            })}
            
        </>

    );
};